/*
  Mobile navigation drawer.
  - Toggle via [data-mobile-nav-open] / [data-mobile-nav-close]
  - ESC closes, click on backdrop closes
  - Body scroll lock while open
  - Focus trap inside drawer panel
  - Returns focus to the opener when closing
  - Closes itself when one of its buttons opens the donate modal
  - No external dependencies, defer-loaded
*/
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function init() {
    var drawers = document.querySelectorAll('[data-mobile-nav]');
    if (!drawers.length) return;

    drawers.forEach(function (drawer) {
      setupDrawer(drawer);
    });
  }

  function setupDrawer(drawer) {
    var openButtons = document.querySelectorAll(
      '[data-mobile-nav-open][aria-controls="' + drawer.id + '"]'
    );
    var closeTargets = drawer.querySelectorAll('[data-mobile-nav-close]');
    var panel = drawer.querySelector('[data-mobile-nav-panel]');
    if (!panel) return;

    var lastOpener = null;
    var isOpen = false;

    function getFocusable() {
      var nodes = panel.querySelectorAll(FOCUSABLE);
      return Array.prototype.filter.call(nodes, function (el) {
        return !el.hasAttribute('disabled') && el.offsetParent !== null;
      });
    }

    function open(opener) {
      if (isOpen) return;
      isOpen = true;
      lastOpener = opener || null;

      drawer.hidden = false;
      // next frame so the transition can run from the hidden state
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
      });

      document.documentElement.classList.add('is-mobile-nav-open');
      document.body.classList.add('is-mobile-nav-open');

      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      // focus the first focusable item after the panel itself
      var focusable = getFocusable();
      var target = focusable[0] || panel;
      target.focus({ preventScroll: true });

      document.addEventListener('keydown', onKeydown, true);
    }

    function close(returnFocus) {
      if (!isOpen) return;
      isOpen = false;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('is-mobile-nav-open');
      document.body.classList.remove('is-mobile-nav-open');

      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });

      document.removeEventListener('keydown', onKeydown, true);

      // Wait for transition before hiding to keep behaviour with reduced motion too
      var styles = window.getComputedStyle(panel);
      var duration = parseDuration(styles.transitionDuration);
      var hide = function () {
        if (!isOpen) drawer.hidden = true;
      };
      if (duration > 0) {
        setTimeout(hide, duration);
      } else {
        hide();
      }

      if (returnFocus !== false && lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus({ preventScroll: true });
      }
      lastOpener = null;
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = getFocusable();
        if (!focusable.length) {
          event.preventDefault();
          panel.focus({ preventScroll: true });
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;

        if (event.shiftKey) {
          if (active === first || active === panel || !panel.contains(active)) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          }
        } else if (active === last) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      }
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        open(btn);
      });
    });

    closeTargets.forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    // «Донат» and «Донат на ЗСУ» open the donate modal over the page; the drawer
    // closes first, or it stays open underneath with its focus trap still on.
    // The modal takes focus, so it is not handed back to the menu button.
    drawer.querySelectorAll('[data-donate-trigger]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(false);
      });
    });
  }

  function parseDuration(value) {
    if (!value) return 0;
    var parts = value.split(',');
    var max = 0;
    parts.forEach(function (raw) {
      var v = raw.trim();
      var ms = v.endsWith('ms')
        ? parseFloat(v)
        : parseFloat(v) * 1000;
      if (!isNaN(ms) && ms > max) max = ms;
    });
    return max;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
